// "use client";

import { useEffect } from "react";
import exampleImages from "./demo-images.js";
import { motion, stagger, useAnimate } from "motion/react";

import Floating, { FloatingElement } from "./parallax-floating";

import Cta from "../../fragments/cta/Cta";
import ComponentWrapper from "../../fragments/component-wrapper/ComponentWrapper";

import CustomImage from "../../fragments/custom-image/CustomImage";

const floatingConfig = [
  {
    depth: 0.5,
    top: "8%",
    left: "2%",
    size: "m",
  },
  {
    depth: 1,
    top: "2%",
    left: "32%",
    size: "s",
  },
  {
    depth: 2,
    top: "2%",
    left: "53%",
    size: "m",
  },
  {
    depth: 1,
    top: "9%",
    left: "83%",
    size: "s",
  },
  {
    depth: 4,
    top: "73%",
    left: "15%",
    size: "l",
  },
  {
    depth: 1,
    top: "80%",
    left: "50%",
    size: "m",
  },
  {
    depth: 2,
    top: "70%",
    left: "77%",
    size: "m",
  },
];

export default function ImageParallax({ block, index }) {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    animate(
      "img",
      { opacity: [0, 1] },
      { duration: 0.5, delay: stagger(0.15) }
    );
  }, []);

  return (
    <ComponentWrapper className="ImageParallax" padding={false}>
      <div className="preview-container" ref={scope}>
        <motion.div
          className="center-content"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.88, delay: 1.5 }}
        >
          {block.heading && (
            <h2 className="theme-neutral dark">{block.heading}</h2>
          )}
          {block.cta && <Cta cta={block.cta} theme="secondary" />}
        </motion.div>

        <Floating sensitivity={-1} className="floating-container">
          {block.parallaxImages.map((image, index) => (
            <FloatingElement
              key={index}
              depth={floatingConfig[index].depth}
              className="floating-element"
              style={{
                top: floatingConfig[index].top,
                left: floatingConfig[index].left,
              }}
            >
              {/* <motion.img
                initial={{ opacity: 0 }}
                src={image.url}
                className={`floating-image floating-image-${floatingConfig[index].size}`}
              /> */}
              <div
                className={`floating-image floating-image-${floatingConfig[index].size}`}
              >
                <CustomImage image={image} fill={false} sizes={"33vw"} />
              </div>
            </FloatingElement>
          ))}
        </Floating>
      </div>
    </ComponentWrapper>
  );
}
